import { useTranslation } from 'react-i18next';

import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useActiveWidgetSlotConfiguration } from '@/hooks/useWidgetConfigurationByOrganizationId';

import { PortfolioPageLayout } from '../../components/PortfolioPageLayout';
import { NaturalCapitalTables } from './components/NaturalCapitalTables';

export const PortfolioNaturalCapitalPage = () => {
  const { t } = useTranslation();

  const defaultWidgetConfiguration = useDefaultWidgetConfiguration();

  const customWidgetSlotsConfiguration = useActiveWidgetSlotConfiguration(
    'default_template_natural_capital',
    WidgetType.t_page,
  );
  const widgetSlotsConfiguration = customWidgetSlotsConfiguration ?? defaultWidgetConfiguration;

  return (
    <PortfolioPageLayout title={t('navbar.natureCapital')} showFilters={true}>
      <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
      <NaturalCapitalTables />
    </PortfolioPageLayout>
  );
};

const useDefaultWidgetConfiguration = () => {
  return {
    name: 'default_template_natural_capital',
    type: WidgetType.t_page,
    widgets: [
      {
        name: 'capital_summary_row',
        type: WidgetType.a_stack,
        visible: false,
        relatedData: {
          direction: 'row',
          spacing: 6,
          className: 'flex-wrap lg:flex-nowrap items-stretch',
        },
        widgets: [
          {
            name: DefaultWidgetNames.default_total_account_value_card,
            type: WidgetType.o_total_account_value,
            visible: false,
          },
        ],
      },
      {
        name: DefaultWidgetNames.default_two_cards_section,
        type: WidgetType.a_stack,
        visible: true,
        relatedData: {
          className: 'flex flex-col lg:grid lg:grid-cols-2 justify-center gap-4',
        },
        widgets: [
          {
            name: DefaultWidgetNames.default_land_distribution_chart,
            type: WidgetType.o_c_land_distribution_chart,
            visible: true,
          },
          {
            name: DefaultWidgetNames.default_earnings_chart,
            type: WidgetType.o_c_earnings_chart,
            visible: false,
          },
          {
            name: DefaultWidgetNames.default_nca_metrics_sidebar,
            type: WidgetType.a_stack,
            visible: true,
            relatedData: {
              direction: 'column',
              spacing: 4,
              className: 'flex flex-col h-full max-w-md ml-auto',
            },
            widgets: [
              {
                name: DefaultWidgetNames.default_total_account_value_card,
                type: WidgetType.o_total_account_value,
                visible: true,
              },
              {
                name: DefaultWidgetNames.default_stewarded_value_card,
                type: WidgetType.o_stewarded_value,
                visible: true,
              },
              {
                name: DefaultWidgetNames.default_ecological_integrity_card,
                type: WidgetType.o_ecological_integrity_index,
                visible: true,
              },
            ],
          },
        ],
      },
    ],
  };
};
